export default function Footer() {
    return (
        <div className="container-fluid bg-light text-center p-4">
            <p>&copy; Trailblazer IT Solutions.</p>
        </div>
    )
}